<template>
  <div style="background-color: #F8F9FB;">
    <hhead></hhead>
    <crm-nav></crm-nav>
    <div class="team_box">
      <div
        class="team"
        :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          padding: '25px 35px',
        }"
      >
        <!-- tab切换 -->
        <div class="team_tab">
          <span
            :style="{
              color: active == '1' ? '#5B85FF' : '#0A101E',
              borderBottom: active == '1' ? '2px solid #5B85FF' : 'none',
            }"
            @click="team"
            >提醒条件</span
          >
          <span
            :style="{
              color: active == '2' ? '#5B85FF' : '#0A101E',
              borderBottom: active == '2' ? '2px solid #5B85FF' : 'none',
            }"
            @click="apply"
            >提醒设置</span
          >
        </div>

        <div
          v-if="active == '1'"
          class="addBtn"
          style="width: 92px;margin-top: 0;"
          @click="add"
        >
          <i class="el-icon-plus"></i>添加
        </div>
        <!-- 提醒条件 -->
        <div class="teamList" v-if="active == '1' ? true : false">
          <div class="table" style="width: 97%;margin: 0;">
            <el-table
              :data="tableList"
              border
              size="medium"
              style="width: 100%"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
            >
              <el-table-column prop="typeName" label="提醒类别">
              </el-table-column>

              <el-table-column prop="condValue" label="条件"> </el-table-column>
              <el-table-column prop="condValue" label="是否提醒">
                <template slot-scope="scope">
                  <span>{{ scope.row.sentInvestor ? '是' : '否' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="删除">
                <template slot-scope="scope">
                  <span
                    @click="delBtn(scope.row.id)"
                    style="cursor: pointer;color: #5b85ff;"
                    class="iconfont icon-shanchu decoration"
                  ></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 提醒设置 -->
        <div class="teamList" v-if="active == '2' ? true : false">
          <div class="setBox">
            <!-- 邮箱 -->
            <div class="f_Box">
              <el-checkbox v-model="c_email">企业邮箱</el-checkbox>
              <div class="inpBox">
                <div v-for="(item, i) of items" style="position: relative;">
                  <el-input
                    style="margin-left: 20px;"
                    v-model="items[i]"
                    :key="i"
                    placeholder="请输入邮箱"
                  ></el-input
                  ><span
                    class="iconfont icon-shanchu"
                    v-show="items.length > 1"
                    style="font-size:16px;cursor: pointer;position: absolute;right: -40px;top: 5px;margin-top: 0;color: #5B85FF;"
                    @click="removeBtn(i)"
                  ></span>
                </div>
                <!-- <p>*需提供邮箱授权码</p> -->
                <p
                  class="el-icon-plus"
                  style="margin-left: 40px;cursor: pointer;"
                  @click="onAdd"
                >
                  添加邮箱
                </p>
              </div>
            </div>

            <!-- 短信-->
            <div class="f_Box">
              <el-checkbox disabled v-model="dx">短信提醒</el-checkbox>
              <div class="inpBox">
                <span>当前短信剩余条数0</span>
                <span class="spanBtn">充值(0.1元/条)</span>
              </div>
            </div>

            <!-- 企业微信-->
            <!-- <div class="f_Box">
              <el-checkbox disabled v-model="wx">企业微信</el-checkbox>
              <div class="inpBox" style="margin-left: 20px;">
                <el-input
                  disabled
                  v-model="appid"
                  placeholder="请输入appid"
                ></el-input>

                <el-input
                  v-model="secret"
                  placeholder="请输入secret"
                  disabled
                ></el-input>

                <el-input
                  v-model="agentid"
                  placeholder="请输入agentid"
                  disabled
                ></el-input>
             
                <p>如需使用企业微信功能，请联系客服。</p>
              </div>
            </div> -->
            <div class="saveBtn" @click="save">保存</div>
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in-linear">
      <!-- 添加条件 -->
      <div class="popContainer" v-show="condition">
        <div
          class="add"
          :style="{ width: '750px', paddingBottom: '20px', marginTop: '250px' }"
        >
          <div class="close"></div>
          <div class="Top" :style="{ width: '750px' }">
            条件设置
          </div>
          <span
            class="close iconfont icon-close_round_fill_bold
          "
            @click="close"
          ></span>
          <div class="form_box_">
            <el-select v-model="type" placeholder="请选择类型">
              <el-option
                v-for="item in option1"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <!-- <el-select v-model="tj" placeholder="请选择条件">
              <el-option
                v-for="item in option2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> -->

            <el-input v-model="input" type="number" placeholder=""></el-input>

            <el-checkbox v-model="checked">提醒合作方</el-checkbox>
          </div>
          <div class="form_btn">
            <!-- <button @click="close">取消</button> -->
            <button @click="submit">保存</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import hhead from '../header/index';
import crmNav from '../../../components/crmNav/index';
import './style.css';
export default {
  components: { hhead, crmNav },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      active: '1',
      tableList: [], //提醒列表
      c_email: '', //企业邮箱
      i_email: '', //企业邮箱
      dx: '', // 短信
      wx: false, //微信
      phone: '', //手机号
      appid: '',
      secret: '',
      agentid: '',
      condition: false,
      input: '',
      option1: [],
      option2: [],
      type: '',
      tj: '',
      items: [''],
      set: '',
      checked: false,
    };
  },
  mounted() {
    this.pageAxios();
    this.set_();
  },

  methods: {
    set_() {
      this.$axios
        .post(
          //查询设置
          '/crm/remind/querySettings',
          { apiToken: this.$store.state.usermsg.apiToken }
        )
        .then((res) => {
          //   console.log(res);
          if (res.data.code == 200) {
            this.c_email = res.data.data.mailActive;
            this.items = res.data.data.email.split(',');
          }
        });
    },
    delBtn(id) {
      //删除

      this.$confirm(`确认删除该条件吗？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.$axios
            .post('/crm/remind/del', {
              apiToken: this.$store.state.usermsg.apiToken,
              remId: id,
            })
            .then((res) => {
              //   console.log(res);
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.pageAxios();
                // this.$alert('操作成功', {
                //   confirmButtonText: '确定',
                //   type: 'success',
                //   center: true,
                // })

                //   .then(() => {})
                //   .catch(() => {});
              } else {
                this.$alert(res.data.message, {
                  confirmButtonText: '确定',
                  type: 'success',
                  center: true,
                })
                  .then(() => {})
                  .catch(() => {});
              }
            });
        })
        .catch(() => {});
    },
    submit() {
      //提交条件设置
      if (this.type && this.input) {
        this.$axios
          .post('/crm/remind/addRemind', {
            apiToken: this.$store.state.usermsg.apiToken,
            type: this.type,
            sentInvestor: this.checked,
            condValue: this.input,
          })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.clear();
              this.set_();
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$alert('请选择提醒类型并填写值', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    save() {
      //保存
      if (this.c_email) {
        // console.log(this.c_email);
        let email = '';
        this.items.forEach((item) => {
          if (item) {
            email += ',' + item;
          } else {
            // this.$alert('请确认邮箱填写完整', {
            //   confirmButtonText: '确定',
            //   type: 'error',
            //   center: true,
            // })
            //   .then(() => {})
            //   .catch(() => {});
          }
        });
        this.i_email = email.replace(',', '');
        // console.log(this.i_email);
        this.$axios
          .post('/crm/remind/choseSettings', {
            apiToken: this.$store.state.usermsg.apiToken,
            mailActive: this.c_email,
            email: this.i_email,
          })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.set_();
              this.$alert('保存成功', {
                confirmButtonText: '确定',
                type: 'success',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      } else {
        this.$axios
          .post('/crm/remind/choseSettings', {
            apiToken: this.$store.state.usermsg.apiToken,
            mailActive: this.c_email,
            email: '',
          })
          .then((res) => {
            // console.log(res);
            this.tokenInvalid(res);
            if (res.data.code == 200) {
              this.set_();
              this.$alert('保存成功', {
                confirmButtonText: '确定',
                type: 'success',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      }
    },
    removeBtn(i) {
      //删除邮箱
      //   console.log(i);
      this.items.splice(i, 1);
    },
    onAdd() {
      //添加邮箱
      this.items.push('');
    },
    add() {
      this.condition = true;
      this.$axios
        .post('/crm/remind/queryRoleType', {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          //   console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.option1 = res.data.data;
          }
        });
    },
    clear() {
      //清除输入框
      this.i_email = '';
      this.condition = false;
      this.input = '';
      this.pageAxios();
    },
    close() {
      this.condition = false;
    },
    team() {
      //团队成员按钮
      this.active = '1';
    },
    apply() {
      //审批按钮
      this.active = '2';
    },
    pageAxios() {
      this.$axios
        .post('/crm/remind/queryAllRemind', {
          apiToken: this.$store.state.usermsg.apiToken,
        })
        .then((res) => {
          //   console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.tableList = res.data.data;
          }
        });
    },
  },
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/view/crm/remindSet/index.vue